import React from 'react'
import PricingCard from './PricingCard/PricingCard'
import PricingTable from './PricingTable/PricingTable'
import PricingCarousel from './PricingCarousel/PricingCarousel'
import PricingSomething from './PricingSomething/PricingSomething'
import PricingFaqs from './PricingFaqs/PricingFaqs'

function Pricing() {
  return (
    <div>
        <PricingCard/>
        <PricingTable/>
        <PricingCarousel/>
        <PricingSomething/>
        <PricingFaqs/>
    </div>
  )
}

export default Pricing